<template>
  <div class="resources">
    <!-- 创建公司 -->
    <div class="resources-top">
      <div class="welcome">Hi，欢迎使用人力资源！</div>
      <div class="create-company">
        <div class="create-company-tips">
          <p class="title">快速创建劳务公司</p>
          <p class="sub-title">从设置名称开始，创建并管理你的劳务公司</p>
        </div>
        <el-button @click="createCompany" class="btn-blue" icon="el-icon-plus">创建公司</el-button>
      </div>
    </div>

    <!-- 人力资源列表 -->
    <div class="resources-main">
      <div class="company-row" v-for="(item, index) in laborServiceCompanyList" :key="index">
        <div class="company-row-content">
          <div class="company-name">
            <div class="company-name-left">
              <img src="../../../../../assets/images/supplier/company-img.png" class="company-img">
              <p class="name">{{ item.name }}</p>
            </div>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <img src="../../../../../assets/images/supplier/more.png" class="more">
              </span>
              <el-dropdown-menu slot="dropdown" class="mod-human">
                <el-dropdown-item :command="beforeHandleCommand(item, 'mod')">编辑</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="head">
            <span>负责人</span>
            <span>{{ item.headName }}</span>
          </div>
          <div class="phone">
            <span>手机号</span>
            <span>{{ item.phone }}</span>
          </div>
          <div class="time">
            <span>上班时间</span>
            <span>{{ item.time }}</span>
          </div>
          <div class="info">
            <div class="info-row">
              <p class="info-row-content">{{ item.temporary }}</p>
              <p class="info-row-title">临时工(元/时)</p>
            </div>
            <div class="info-row">
              <p class="info-row-content">{{ item.cycle }}</p>
              <p class="info-row-title">周期工(元/时)</p>
            </div>
            <div class="info-row">
              <p class="info-row-content">{{ item.longCycle }}</p>
              <p class="info-row-title">长周期工(元/时)</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/编辑公司 -->
    <el-drawer :title="drawerTitle" :visible.sync="drawer" :wrapperClosable="false" :before-close="handleCloseDrawer">
      <el-form ref="humanForm" :rules="humanFormRules" :model="humanForm">
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="humanForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="header">
          <el-input v-model="humanForm.header" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNo">
          <el-input v-model="humanForm.phoneNo" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="上班时间" prop="time">
          <el-time-picker v-model="humanForm.time" format="HH:mm" value-format="HH:mm" placeholder="请选择">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="临时工工资" prop="temporary">
          <el-input v-model="humanForm.temporary" @input="inputTemproary(humanForm.temporary)" placeholder="请输入"
            class="suffix-tips">
            <span slot="suffix">(元/时)</span>
          </el-input>
        </el-form-item>
        <el-form-item label="周期工工资" prop="cycle">
          <el-input v-model="humanForm.cycle" @input="inputCycle(humanForm.cycle)" placeholder="请输入"
            class="suffix-tips">
            <span slot="suffix">(元/时)</span>
          </el-input>
        </el-form-item>
        <el-form-item label="长周期工工资" prop="longCycle">
          <el-input v-model="humanForm.longCycle" @input="inputLongCycle(humanForm.longCycle)" placeholder="请输入"
            class="suffix-tips">
            <span slot="suffix">(元/时)</span>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submit('humanForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import HumanResoources from '@/models/system/human-resources.js'
import LaborServiceCompanyListMixins from '@/common/mixins/labor-service-company.js'
import { getDecimal } from "common/js/util";
export default {
  mixins: [LaborServiceCompanyListMixins],

  data() {
    const isTelephone = (mobileNumber) => {
      const reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      return reg.test(mobileNumber);
    };
    const validateTelephone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        if (!isTelephone(value)) {
          callback(new Error("请输入有效手机号码"));
        }
        callback();
      }
    };
    return {
      drawer: false,
      drawerTitle: '创建',
      humanForm: {
        id: null,
        name: "",
        header: "",
        phoneNo: "",
        time: "",
        temporary: "",
        cycle: "",
        longCycle: ""
      },
      humanFormRules: {
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        header: [{ required: true, message: "请输入负责人", trigger: "blur" }],
        phoneNo: [
          { required: true, validator: validateTelephone, trigger: "blur" }
        ],
        time: [
          { required: true, message: "请选择上班时间", trigger: "change" }
        ],
        temporary: [
          { required: true, message: "请输入临时工工资", trigger: "blur" }
        ],
        cycle: [
          { required: true, message: "请输入周期工工资", trigger: "blur" }
        ],
        longCycle: [
          { required: true, message: "请输入长周期工工资", trigger: "blur" }
        ],
      },
    }
  },

  created() {
    this.initLaborServiceCompanyList()
  },

  methods: {
    createCompany() {
      this.drawerTitle = '创建'
      this.drawer = true
    },
    
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command){
      return {
        'value': value,
        'command':command,
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "mod":
          this.humanForm.id = command.value.id
          this.humanForm.name = command.value.name
          this.humanForm.header = command.value.headName
          this.humanForm.phoneNo = command.value.phone
          this.humanForm.time = command.value.time
          this.humanForm.temporary = command.value.temporaryCopy
          this.humanForm.cycle = command.value.cycleCopy
          this.humanForm.longCycle = command.value.longCycleCopy
          this.drawerTitle = '编辑'
          this.drawer = true
        break;
      }
    },

    
    handleCloseDrawer() {
      this.$refs['humanForm'].resetFields();
      this.drawer = false;
    },

    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let id = this.humanForm.id;
          let name = this.humanForm.name;
          let contact = this.humanForm.header;
          let phone = this.humanForm.phoneNo;
          let startTime = this.humanForm.time;
          let temporary = this.humanForm.temporary;
          let cycle = this.humanForm.cycle;
          let longCycle = this.humanForm.longCycle;
          let laborRuleReqVoList = [
            {
              type:1,
              hourSalary: cycle
            },
            {
              type:2,
              hourSalary: temporary
            },
            {
              type:3,
              hourSalary: longCycle
            }
          ]
          let data = {
            name,
            contact,
            phone,
            startTime,
            laborRuleReqVoList
          };
          if (id) {
            data.id = id
            HumanResoources.postModCompany(data).then(res => {
              if (res.success) {
                this.handleCloseDrawer();
                this.initLaborServiceCompanyList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            });
          } else {
            HumanResoources.postAddCompany(data).then(res => {
              if (res.success) {
                this.handleCloseDrawer();
                this.initLaborServiceCompanyList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    inputTemproary(v) {
      this.humanForm.temporary = getDecimal(v)
    },

    inputCycle(v) {
      this.humanForm.cycle = getDecimal(v)
    },

    inputLongCycle(v) {
      this.humanForm.longCycle = getDecimal(v)
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/system/resources.scss';
</style>
